import React from "react";

import { faFilePdf } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Icon } from "@performyard/py-components";

type Props = {
	payload: {
		filename: string;
		content_type: string;
	};
};

export const PdfGuidePreview = ({ payload }: Props): React.ReactElement => (
	<div className="flex items-center gap-4 rounded-sm bg-neutral-1 p-4 ring-1 ring-neutral-2">
		<div className="flex size-12 items-center justify-center rounded-sm bg-neutral-2">
			<Icon icon={faFilePdf} color="neutral-7" size={24} />
		</div>
		<div className="min-w-0 flex-1">
			<div className="truncate text-paragraph-2 font-semi-bold text-neutral-9">{payload.filename}</div>
			<div className="mt-0.5 text-caption text-neutral-7">{payload.content_type}</div>
		</div>
	</div>
);

export default PdfGuidePreview;
